// extracted by mini-css-extract-plugin
export default {"products":"Products_products__0uouM","container":"Products_container__g6x15","content":"Products_content__03EUc","links":"Products_links__mPNrF","link":"Products_link__2xvwO"};